import { commonEnvironmentData } from './common-environment';

export const environment = Object.assign(commonEnvironmentData, {
    production: true,
});
